var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsideBottomBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 634,
    height: 286,
    viewBox: "0 0 634 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 11.6C7.4 7.8 3.6 4 0 0V175C20.3 185.3 42 193 64.5 197.6L139.3 81C90.9 70.6 46.5 46.5 11.3 11.6Z",
    fill: "url(#paint0_linear_10348_174)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 286H335.3L280.4 168.6C216.2 173.2 154.7 196.3 103.2 235.3C82.9 250.2 64.4 267.2 48 286Z",
    fill: "url(#paint1_linear_10348_174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10348_174",
    x1: -1.2,
    y1: 2.5,
    x2: 86.3,
    y2: 157.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#069EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CD80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10348_174",
    x1: 253.7,
    y1: 216.1,
    x2: 98.8,
    y2: 390.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#069EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CD80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideBottomBg);
export default __webpack_public_path__ + "static/media/asideBottomBG.0dac9f860b52c2ee7d12231a5b3ece72.svg";
export { ForwardRef as ReactComponent };